import {useEffect, useState} from "react";
import './Barcode.scss'
import T from "../../../shared/component/t/T";
import Scanner from "./Scanner";
import Storage from "../../../helpers/Storage"



export default function Barcode(props) {
	const [accessCamera, setAccessCamera] = useState(false)
	const [devices, setDevices] = useState([]);
	const [selectedDeviceId, setSelectedDeviceId] = useState(null);

	useEffect(() => {
		let stream
		const getCameraPermission = async () => {
			try {
				stream = await navigator.mediaDevices.getUserMedia({video: true});
				stream.getTracks().forEach(track => track.stop()); // Stop the stream to release resources
				return true;
			} catch (error) {
				console.error("Camera access denied or error:", error);
				return false;
			}
		};

		getCameraPermission().then((hasAccess) => {
			if (hasAccess) {
				getCameraDevices()
			} else {
				setAccessCamera(false)
			}
		});

		return () => {
			stream?.getTracks().forEach(track => track.stop()); // Stop the stream to release resources
		}
	}, []);
	
	const initialCamera = (devices = []) => {
		let prevData = Storage.getUserDefaultCamera()
		let devicesIDs = devices.map(item => item.deviceId)
		let resCam
		if (prevData && devicesIDs?.includes(prevData))
			resCam = prevData
		else {
			resCam = devicesIDs[devicesIDs.length - 1]
		}
		Storage.setUserDefaultCamera(resCam)
		setSelectedDeviceId(resCam)
		setAccessCamera(true)
	}

	const getCameraDevices = async () => {
		const availableDevices = await navigator.mediaDevices.enumerateDevices();
		const availableVideoDevices = availableDevices.filter(
			(device) => device.kind === 'videoinput'
		);
		setDevices(availableVideoDevices);
		initialCamera(availableVideoDevices)
	}

	const onChange = (res) => {
		props.onChange(res)
	}

	const handleCameraChange = (event) => {
		setSelectedDeviceId(event.target.value);
		Storage.setUserDefaultCamera(event.target.value)
	};
	

	return <>
		{devices?.length > 0
			? <>
				<div className="camera-selection">
					<label htmlFor="camera-select">انتخاب دوربین:</label>
					<select id="camera-select" value={selectedDeviceId} onChange={handleCameraChange}>
						{devices.map((device) => (
							<option key={device.deviceId} value={device.deviceId}>
								{device.label || `Camera ${device.deviceId}`}
							</option>
						))}
					</select>
				</div>
				{(accessCamera && selectedDeviceId)
					? <div className="scanner-container">
						<Scanner onDetect={onChange}
						         deviceId={selectedDeviceId}
						/>
					</div>
					: <p><T toeken={'loading'}/></p>
				}
			</>
			: <p className={'w-100 text-center my-5 py-5'}><T token={'no_camera_found'}/></p>
		}
	</>
}